import { render, staticRenderFns } from "./TenantView.vue?vue&type=template&id=8af5822a&scoped=true&"
import script from "./TenantView.vue?vue&type=script&lang=js&"
export * from "./TenantView.vue?vue&type=script&lang=js&"
import style0 from "./TenantView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TenantView.vue?vue&type=style&index=1&id=8af5822a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af5822a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8af5822a')) {
      api.createRecord('8af5822a', component.options)
    } else {
      api.reload('8af5822a', component.options)
    }
    module.hot.accept("./TenantView.vue?vue&type=template&id=8af5822a&scoped=true&", function () {
      api.rerender('8af5822a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboards/TenantView.vue"
export default component.exports